// phoneNumberFormatter.js

export function formatPhoneNumber(phoneNumber) {
  const numericPhoneNumber = phoneNumber.replace(/\D/g, "");

  if (numericPhoneNumber.length === 10) {
    return `1-${numericPhoneNumber.slice(0, 3)}-${numericPhoneNumber.slice(
      3,
      6
    )}-${numericPhoneNumber.slice(6)}`;
  } else {
    //alert("Invalid phone number");
    return numericPhoneNumber;
  }
}
